VIV.behaviours.tabs = (function () {

    const baseClass = 'tabs';

    /**
     * Attach the behaviour to the element
     *
     * @param context
     */
    const attach = function (context) {
        const tabWrappers = context.querySelectorAll('.tabs');

        tabWrappers.forEach(element => {
            init(element);
        });

        // Keyboard event listeners
        if (tabWrappers.length) {
            addWindowKeyDownEventListener();
        }
    };

    /**
     * Initialize the tabs
     *
     * @param element
     */
    const init = function (element) {
        const links = element.querySelectorAll(`.${baseClass}__link`);

        // Add event listeners for links
        links.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                handleLinkClick(link, links);
            });
        });
    };

    /**
     * Handles the click event on a link, show the corresponding tab
     *
     * @param clickedLink
     * @param allLinks
     */
    const handleLinkClick = function (clickedLink, allLinks) {
        const targetSelector = '#' + clickedLink.getAttribute('href').split('#')[1];
        const targetTab = document.documentElement.querySelector(targetSelector);

        if (targetTab) {
            const tabs = targetTab.parentElement.querySelectorAll(`.${baseClass}__tab`);

            allLinks.forEach((link) => {
                if (link === clickedLink) {
                    link.focus();
                    link.setAttribute('tabindex', '0');
                    link.setAttribute('aria-current', 'true');
                    link.classList.add(`${baseClass}__link--active`);
                } else {
                    link.setAttribute('tabindex', '-1');
                    link.setAttribute('aria-current', 'false');
                    link.classList.remove(`${baseClass}__link--active`);
                }
            });

            tabs.forEach((tab) => {
                if (tab === targetTab) {
                    targetTab.removeAttribute('hidden');
                } else {
                    tab.setAttribute('hidden', 'hidden');
                }

            });
        }
    };

    /**
     * Handle keyboard support when tab is focused (left / right)
     */
    const addWindowKeyDownEventListener = function () {
        window.addEventListener('keydown', function (e) {
            const focussedLink = document.documentElement.querySelector(`.${baseClass}__link:focus`);
            if (focussedLink && (e.code === 'ArrowLeft' || e.code === 'ArrowRight')) {
                if (e.code === 'ArrowRight') {
                    if (focussedLink === focussedLink.parentElement.lastElementChild) {
                        focussedLink.parentElement.firstElementChild.click();
                    } else {
                        focussedLink.nextElementSibling.click();
                    }
                } else {
                    if (focussedLink === focussedLink.parentElement.firstElementChild) {
                        focussedLink.parentElement.lastElementChild.click();
                    } else {
                        focussedLink.previousElementSibling.click();
                    }
                }
            }
        });
    }

    return {
        attach: attach
    }
})();
